import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";
import { nominationDetailPath } from "../utils/cargoOpsPaths";

interface NominationLinksProps {
  nominations: { id: string; refOrderNumber: number }[];
}

const NominationLinks: React.FC<NominationLinksProps> = ({ nominations }) => {
  const { t } = useTranslation();
  return (
    <Box
      data-testid="drybulk-nomination-links"
      sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}
    >
      <CheckCircleOutlineIcon fontSize="small" color="success" aria-hidden />
      <Typography variant="body2" component="span">
        {t(`${DRYBULK_CARGO_OPS_LANG_BASE}.nomination-number`)}
      </Typography>
      {nominations.length === 0 ? (
        <Typography variant="body2" component="span">
          —
        </Typography>
      ) : (
        nominations.map((nomination, index) => (
          <React.Fragment key={nomination.id}>
            {index > 0 && <span>, </span>}
            <Link
              component={RouterLink}
              underline="hover"
              to={nominationDetailPath(nomination.id)}
              data-testid={`drybulk-nomination-link-${nomination.refOrderNumber}`}
            >
              {nomination.refOrderNumber}
            </Link>
          </React.Fragment>
        ))
      )}
    </Box>
  );
};

export default NominationLinks;
